<template>
	<div class="wrapper">
		<top-bar/>
		<side-bar :disabledOptions="showNoData"/>
		<transition v-show="!showNoData" name="fade" mode="out-in">
			<router-view/>
		</transition>
		<no-data v-show="showNoData"/>
	</div>
</template>

<script>
import mediator from '@/mediator';
export default {
	computed: {
		showNoData () {
			return this.$store.state.ui.showNoData;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/academicLevels/AcademicLevels.vue